import type { ISort } from '../ui/table/table.types';

export const stringifySort = <T = string>(sort: ISort<T>): string =>
  `sort=${sort.sort}&direction=${sort.direction}`;
